import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// 首页
import { HomeComponent } from "./home/home.component";
// 走进中心
import { EnterCenterComponent } from './enterCenter/enter-center/enter-center.component';
import { CenterOverviewComponent } from './enterCenter/center-overview/center-overview.component'
import { CenterProgressComponent } from './enterCenter/center-progress/center-progress.component';
import { CenterViewComponent } from './enterCenter/center-view/center-view.component';
import { OrganizationComponent } from './enterCenter/organization/organization.component';
// 中心服务
import { CentralServicesComponent } from "./centralServices/central-services/central-services.component";
import { ComplexMappingComponent } from "./centralServices/complex-mapping/complex-mapping.component";
import { DataIntroduceComponent } from "./centralServices/data-introduce/data-introduce.component";
import { NatureComponent } from "./centralServices/nature/nature.component";
import { ProductionComponent } from "./centralServices/production/production.component";
import { SkyLandComponent } from "./centralServices/sky-land/sky-land.component";
import { SpaceInfoComponent } from "./centralServices/space-info/space-info.component";
import { ThreeSComponent } from "./centralServices/three-s/three-s.component";
// 信息动态
import { InfoVarietyComponent } from "./information/info-variety/info-variety.component";
import { CenterNewsComponent } from "./information/center-news/center-news.component";
import { IndustryNewsComponent } from "./information/industry-news/industry-news.component";
import { NoticeAnnouncementComponent } from "./information/notice-announcement/notice-announcement.component";
// 数据管理
import { DataManagerComponent } from "./manager/data-manager/data-manager.component";
import { CartComponent } from "./manager/cart/cart.component";
import { DataQueryComponent } from "./manager/data-query/data-query.component";
import { DownloadComponent } from "./manager/download/download.component";
// 行业应用
import { IndustryAppComponent } from "./industryApplication/industry-app/industry-app.component";
import { SthjComponent } from "./industryApplication/sthj/sthj.component";
import { YjglComponent } from "./industryApplication/yjgl/yjgl.component";
import { ZrzyComponent } from "./industryApplication/zrzy/zrzy.component";
import { ZhfzComponent } from "./industryApplication/zhfz/zhfz.component";
import { LycyComponent } from "./industryApplication/lycy/lycy.component";
import { CxzjComponent } from "./industryApplication/cxzj/cxzj.component";
import { WwbhComponent } from "./industryApplication/wwbh/wwbh.component";
import { JtysComponent } from "./industryApplication/jtys/jtys.component";
import { NyncComponent } from "./industryApplication/nync/nync.component";
import { GyssComponent } from "./industryApplication/gyss/gyss.component";
import { HsgsComponent } from "./industryApplication/hsgs/hsgs.component";
// 综合体系
import { ServiceExampleComponent } from "./serviceCase/service-example/service-example.component";
import { ServiceCaseComponent } from "./serviceCase/service-case/service-case.component";
// 星群资源
import { OtherSatComponent } from "./starResources/other-sat/other-sat.component";
import { OutsideSatComponent } from "./starResources/outside-sat/outside-sat.component";
import { ProductDisplayComponent } from "./starResources/product-display/product-display.component";
import { StarResourcesComponent } from "./starResources/star-resources/star-resources.component";
// 政策规定
import { NationregulationsComponent } from "./policyregulations/nationregulations/nationregulations.component";
import { ProvinceregulationsComponent } from "./policyregulations/provinceregulations/provinceregulations.component";
import { CenterregulationsComponent } from "./policyregulations/centerregulations/centerregulations.component";
import { PolicyRegulationsComponent } from "./policyregulations/policy-regulations/policy-regulations.component";
// 联系我们
import { ContactWaysComponent } from "./contactUs/contact-ways/contact-ways.component";
import { TalentSeekComponent } from "./contactUs/talent-seek/talent-seek.component";
import { ContactUsComponent } from "./contactUs/contact-us/contact-us.component";

// 其他
import { DetailComponent } from './detail/detail.component';
import { PolicyDetailComponent } from "./policy-detail/policy-detail.component";

/**app路由模块 */
const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full"
  },
  {
    path: "home",
    component: HomeComponent,
  },
  {
    path: "detail",
    component: DetailComponent
  },
  {
    path: "policyDetail",
    component: PolicyDetailComponent
  },
  // 走进中心
  {
    path: "enterCenter",
    component: EnterCenterComponent,
    children: [
      {
        path: "centerOverview",
        component: CenterOverviewComponent
      },
      {
        path: "organization",
        component: OrganizationComponent
      },
      {
        path: "centerProgress",
        component: CenterProgressComponent
      },
      {
        path: "centerView",
        component: CenterViewComponent
      },
    ],
  },
  // 中心服务
  {
    path: "centralServices",
    component: CentralServicesComponent,
    children: [
      {
        path: "complexMapping",
        component: ComplexMappingComponent
      },
      {
        path: "dataIntroduce",
        component: DataIntroduceComponent
      },
      {
        path: "nature",
        component: NatureComponent
      },
      {
        path: "production",
        component: ProductionComponent
      },
      {
        path: "skyLand",
        component: SkyLandComponent
      },
      {
        path: "spaceInfo",
        component: SpaceInfoComponent
      },
      {
        path: "threeS",
        component: ThreeSComponent
      },
    ],
  },
  // 信息动态
  {
    path: "infoVariety",
    component: InfoVarietyComponent,
    children: [
      {
        path: "centerNews",
        component: CenterNewsComponent
      },
      {
        path: "industryNews",
        component: IndustryNewsComponent
      },
      {
        path: "noticeAnnouncement",
        component: NoticeAnnouncementComponent
      },
    ],
  },
  // 数据管理
  {
    path: "dataManager",
    component: DataManagerComponent,
    children: [
      {
        path: 'dataQuery',
        component: DataQueryComponent
      },
      {
        path: 'cart',
        component: CartComponent
      },
      {
        path: 'download',
        component: DownloadComponent
      },
    ],
  },


  // 行业应用
  {
    path: "industryApp",
    component: IndustryAppComponent,
    children: [
      {
        path: "sthj",
        component: SthjComponent
      },
      {
        path: "yjgl",
        component: YjglComponent
      },
      {
        path: "zrzy",
        component: ZrzyComponent
      },
      {
        path: "zhfz",
        component: ZhfzComponent
      },
      {
        path: "lycy",
        component: LycyComponent
      },
      {
        path: "cxzj",
        component: CxzjComponent
      },
      {
        path: "wwbh",
        component: WwbhComponent
      },
      {
        path: "jtys",
        component: JtysComponent
      },
      {
        path: "nync",
        component: NyncComponent
      },
      {
        path: "gyss",
        component: GyssComponent
      },
      {
        path: "hsgs",
        component: HsgsComponent
      },
    ],
  },

  // 综合体系
  {
    path: "serviceExample",
    component: ServiceExampleComponent,
    children: [
      {
        path: "serviceCase",
        component: ServiceCaseComponent
      },
    ],
  },

  // 星群资源
  {
    path: "starResources",
    component: StarResourcesComponent,
    children: [
      {
        path: "otherSat",
        component: OtherSatComponent
      },
      {
        path: "outsideSat",
        component: OutsideSatComponent
      },
      {
        path: "productDisplay",
        component: ProductDisplayComponent
      },
    ],
  },
  //政策规定
  {
    path: "policyregulations",
    component: PolicyRegulationsComponent,
    children: [
      {
        path: "nationregulations",
        component: NationregulationsComponent,
      },
      {
        path: "provinceregulations",
        component: ProvinceregulationsComponent
      },
      {
        path: "centerregulations",
        component: CenterregulationsComponent
      },
    ],

  },
  // 联系我们
  {
    path: "contactUs",
    component: ContactUsComponent,
    children: [
      {
        path: "contactWays",
        component: ContactWaysComponent
      },
      {
        path: "talentSeek",
        component: TalentSeekComponent
      },
    ]
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,// 使用锚点标记路由
      // onSameUrlNavigation: 'reload'
    })
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
